module.exports = "/img/3.c46516.webp";